module.exports = __webpack_public_path__ + "img/05n.fc3cab86.png";